import "./cards.component.scss";

function Card({ card, onSetDefault, onDelete }) {
  return (
    <div className="cc-card-wrap">
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <div className="card-icon">
            <div className={`card-brand ${card.brand}`}></div>
          </div>
          <div className="ms-3">
            <div className="grey-text lato-medium">Card number</div>
            <div className="dark-text lato-bold">
              xxxx xxxx xxxx {card.last4}
            </div>
          </div>
        </div>
        <div className="d-flex flex-column justify-content-center">
          <div className="grey-text lato-medium">Expiry</div>
          <div className="dark-text lato-bold">
            {card.expiryMonth?.padStart(2, "0")}/{card.expiryYear}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          {/* <button className="btn action-btn">
            <i className="fa-solid fa-pen-to-square me-1"></i>Edit
          </button> */}
          <button className="btn action-btn ms-2" onClick={onDelete}>
            <i className="fa-solid fa-trash-alt me-1"></i>Delete
          </button>
        </div>
        <div className="d-flex align-items-center">
          <div className="lato-medium font-14 me-2">Set as Default</div>
          <div className="custom-toggle">
            <input
              type="checkbox"
              id={"SetAsDefault" + card.id}
              checked={card.default}
              onChange={onSetDefault}
            />
            <label for={"SetAsDefault" + card.id}>Set as Default</label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
